import { CheckListType } from '@digiwall/goliath-core/proxy';
import { GoliathDocumentsEnumerationTypeCategory } from './../enumeration-types/enumeration-type-categories.constants';

export const ParameterRoutes = [
  {
    route: 'productions',
    label: '::Menu:Settings:Productions',
    sections: [
      {
        label: '::General',
        items: [
          {
            label: `Doc::ProductionDayBooks`,
            route: `production-day-books`,
            icon: 'digi-out-newspaper',
          },
          {
            label: `GoliathCore::Menu:Settings:Checklists`,
            route: `checklists/${CheckListType.Production}`,
            icon: 'digi-out-check',
          },
          {
            label: `::EnumerationCategory:${GoliathDocumentsEnumerationTypeCategory.ProductionBlocked}`,
            route: `enumeration-types/${GoliathDocumentsEnumerationTypeCategory.ProductionBlocked}`,
            icon: 'digi-out-blocking-reason',
          },
          {
            label: `::EnumerationCategory:${GoliathDocumentsEnumerationTypeCategory.Direction}`,
            route: `enumeration-types/${GoliathDocumentsEnumerationTypeCategory.Direction}`,
            icon: 'digi-out-direction',
          },
          {
            label: `::EnumerationCategory:${GoliathDocumentsEnumerationTypeCategory.ProductionFolderStatus}`,
            route: `enumeration-types/${GoliathDocumentsEnumerationTypeCategory.ProductionFolderStatus}`,
            icon: 'digi-out-folder-open',
          },
          {
            label: `::EnumerationCategory:${GoliathDocumentsEnumerationTypeCategory.ProductionFolderLineStatus}`,
            route: `enumeration-types/${GoliathDocumentsEnumerationTypeCategory.ProductionFolderLineStatus}`,
            icon: 'digi-out-form-elements',
          },
          {
            label: `::EnumerationCategory:${GoliathDocumentsEnumerationTypeCategory.ProductionOrderStatus}`,
            route: `enumeration-types/${GoliathDocumentsEnumerationTypeCategory.ProductionOrderStatus}`,
            icon: 'digi-out-paste',
          },
          {
            label: `::EnumerationCategory:${GoliathDocumentsEnumerationTypeCategory.ProductionStepStatus}`,
            route: `enumeration-types/${GoliathDocumentsEnumerationTypeCategory.ProductionStepStatus}`,
            icon: 'digi-out-finishing',
          },
          {
            label: `::Menu:ClassificationTypes`,
            route: `classifications`,
            icon: 'digi-out-enumeration',
          },
          {
            label: `::Menu:Machines`,
            route: `machines`,
            icon: 'digi-out-machinery',
          },
        ],
        isOpen: true,
      },
    ],
  },
];
